var _path, _path2, _g, _path3, _path4, _g2, _g3, _g4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0596 3.45312C42.0815 1.13131 47.0367 1.1313 51.0586 3.45312L77.5244 18.7324C81.5466 21.0547 84.0244 25.3468 84.0244 29.9912V60.5498C84.0243 65.194 81.5463 69.4854 77.5244 71.8076L51.0586 87.0869C47.0365 89.4089 42.0816 89.4089 38.0596 87.0869L11.5938 71.8076C7.57185 69.4854 5.0939 65.194 5.09375 60.5498V29.9912C5.09375 25.3468 7.5716 21.0547 11.5938 18.7324L38.0596 3.45312Z",
    fill: "#F3F0FF",
    stroke: "#CFBFFF",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2475_17951",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 78,
    height: 87
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0591 3.45445C42.8437 1.8468 46.2744 1.84679 49.059 3.45445L78.524 20.4658C81.3086 22.0735 83.024 25.0446 83.024 28.26V62.2824C83.024 65.4978 81.3086 68.469 78.524 70.0767L49.059 87.088C46.2744 88.6957 42.8437 88.6957 40.0591 87.088L10.5942 70.0767C7.80952 68.469 6.0941 65.4978 6.0941 62.2824V28.26C6.0941 25.0446 7.80952 22.0735 10.5942 20.4658L40.0591 3.45445Z",
    fill: "#EDF2FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2475_17951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2226 53.479C16.2957 47.8286 19.1748 42.2372 24.3126 39.7097L41.1333 31.4348C42.1889 30.9155 43.31 30.5419 44.466 30.3242L71.6253 25.2095C78.4765 23.9193 85.1258 28.2632 86.6968 35.0555L93.1227 62.838C94.5221 68.8886 91.4465 75.0841 85.7809 77.6274L46.9186 95.0724C41.597 97.4612 35.3357 96.0129 31.6037 91.5297L23.7313 82.0731C22.2487 80.292 21.2691 78.147 20.8939 75.8602L17.2226 53.479Z",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4207 81.3229C23.726 82.9065 25.1792 84.0277 26.8394 84.0872C26.8488 84.0862 26.8582 84.0851 26.8678 84.0843C26.9201 84.0795 26.9771 84.0764 27.038 84.0762L27.5518 84.0214L27.5625 84.0203L27.5732 84.0193L94.0343 77.7691L82.5673 18.2892L13.8236 31.5422L23.4207 81.3229ZM97.325 77.7986C97.5968 79.2088 96.4998 80.561 94.9672 80.7048L27.8198 87.0195L27.0497 87.1016L27.0237 87.1066L27.0036 87.1065L26.8997 87.1176L26.8476 87.1056C23.6689 87.0851 20.8423 84.9877 20.2535 81.9335L10.5451 31.5761C10.2921 30.2636 11.2281 28.9792 12.6356 28.7079L82.6147 15.2167C84.0184 14.9461 85.3696 15.7859 85.6233 17.1018L97.325 77.7986Z",
    fill: "#CFBFFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2475_17951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 78.1094L24.1424 93.7086L101.768 81.5219L31.7353 73.9795C29.7241 81.737 24.0738 79.9651 21.5 78.1094Z",
    fill: "#B197FC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.3826 43.4832L86.9453 29.8795L84.6689 18.0717L14.1062 31.6754L16.3826 43.4832ZM90.3053 29.8163C90.5368 31.0172 89.568 32.2134 88.1426 32.4882L16.2411 46.3499C14.8152 46.6248 13.4715 45.8743 13.24 44.6736L10.7463 31.7386C10.5148 30.5379 11.4831 29.3416 12.9091 29.0667L84.8105 15.2049C86.236 14.9301 87.5801 15.6804 87.8116 16.8813L90.3053 29.8163Z",
    fill: "#CFBFFF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4515 2.94271L67.0263 2.76188L66.0407 1.37245L61.0928 1.59391L62.4515 2.94271Z",
    fill: "#FFEC99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6127 5.34943L77.4 10.4422L78.2955 7.81768L75.5031 3.21299L74.6127 5.34943Z",
    fill: "#FFC9C9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2475_17951)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.7549,
    y: 44.3622,
    width: 8.86825,
    height: 8.86825,
    rx: 4,
    transform: "rotate(-8.03187 23.7549 44.3622)",
    fill: "#B197FC",
    stroke: "#B197FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6537 42.02C34.9266 42.2298 35.0067 42.6407 34.8326 42.9377L30.3747 50.5431C30.2006 50.8402 29.8382 50.9108 29.5653 50.701L26.071 48.0142C25.7981 47.8044 25.718 47.3935 25.8921 47.0965C26.0661 46.7994 26.4285 46.7288 26.7014 46.9386L29.7016 49.2454L33.8443 42.1778C34.0184 41.8808 34.3807 41.8101 34.6537 42.02Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5554 42.0062C33.8311 41.5359 34.4247 41.4203 34.8569 41.7525C35.2631 42.0649 35.3788 42.6619 35.1196 43.104L30.662 50.7097C30.3863 51.1799 29.7937 51.2954 29.3615 50.9632L25.8668 48.2767C25.4607 47.9643 25.3441 47.3674 25.6032 46.9253C25.8789 46.4549 26.4724 46.3392 26.9047 46.6716L29.6039 48.7465L33.5554 42.0062ZM34.4494 42.2824C34.3359 42.1952 34.2042 42.2214 34.1318 42.345L29.9888 49.4121C29.9403 49.4946 29.8586 49.5526 29.7646 49.571C29.6707 49.5892 29.5732 49.5664 29.4974 49.5081L26.4971 47.2006C26.3836 47.1136 26.2518 47.1397 26.1795 47.2631C26.0907 47.4149 26.135 47.6396 26.2743 47.7468L29.7681 50.4344C29.8816 50.5215 30.0133 50.4952 30.0857 50.3718L34.5433 42.7662C34.6322 42.6144 34.5888 42.3897 34.4494 42.2824Z",
    fill: "#F3F0FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2475_17951)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.1934,
    y: 59.9061,
    width: 8.86825,
    height: 8.86825,
    rx: 4,
    transform: "rotate(-8.03187 26.1934 59.9061)",
    fill: "#B197FC",
    stroke: "#B197FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0921 57.5629C37.3651 57.7728 37.4452 58.1837 37.2711 58.4807L32.8132 66.0861C32.6391 66.3831 32.2767 66.4538 32.0038 66.2439L28.5095 63.5572C28.2366 63.3473 28.1564 62.9364 28.3305 62.6394C28.5046 62.3424 28.867 62.2718 29.1399 62.4816L32.1401 64.7884L36.2828 57.7208C36.4568 57.4237 36.8192 57.3531 37.0921 57.5629Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9938 57.5519C36.2696 57.0817 36.8622 56.9662 37.2944 57.2984C37.7005 57.6109 37.8172 58.2077 37.5581 58.6498L33.0994 66.2546C32.8237 66.725 32.2311 66.8405 31.7988 66.5082L28.3043 63.8226C27.8981 63.5102 27.7826 62.9132 28.0416 62.4711C28.3174 62.0006 28.9099 61.8851 29.3422 62.2175L32.0414 64.2924L35.9938 57.5519ZM36.8869 57.8283C36.7733 57.741 36.6416 57.7663 36.5692 57.8899L32.4272 64.9579C32.3788 65.0403 32.2968 65.0974 32.203 65.1158C32.1089 65.1341 32.0107 65.1114 31.9347 65.053L28.9346 62.7465C28.8212 62.6594 28.6903 62.6848 28.6178 62.8079C28.5288 62.9597 28.5724 63.1854 28.7118 63.2927L32.2065 65.9792C32.3198 66.0661 32.4508 66.0407 32.5232 65.9177L36.9818 58.312C37.0707 58.1602 37.0263 57.9356 36.8869 57.8283Z",
    fill: "#F3F0FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2475_17951)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5723,
    y: 27.8485,
    width: 8.86825,
    height: 8.86825,
    rx: 4,
    transform: "rotate(-8.03187 21.5723 27.8485)",
    fill: "#B197FC",
    stroke: "#B197FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4711 25.5053C32.744 25.7152 32.8241 26.1261 32.65 26.4231L28.1921 34.0285C28.018 34.3255 27.6556 34.3962 27.3827 34.1863L23.8884 31.4996C23.6155 31.2897 23.5353 30.8788 23.7094 30.5818C23.8835 30.2848 24.2459 30.2141 24.5188 30.424L27.519 32.7308L31.6617 25.6631C31.8358 25.3661 32.1981 25.2955 32.4711 25.5053Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3728 25.4944C31.6484 25.0244 32.2412 24.9091 32.6733 25.2409C33.0797 25.5533 33.1962 26.1501 32.937 26.5923L28.4794 34.198C28.2037 34.6682 27.6111 34.7837 27.1788 34.4515L23.6842 31.765C23.278 31.4526 23.1615 30.8557 23.4206 30.4136C23.6963 29.9432 24.2898 29.8275 24.7221 30.1599L27.4214 32.2357L31.3728 25.4944ZM32.2668 25.7707C32.1532 25.6834 32.0216 25.7097 31.9492 25.8332L27.8062 32.9004C27.7577 32.9829 27.676 33.0409 27.582 33.0592C27.4881 33.0775 27.3906 33.0547 27.3147 32.9964L24.3145 30.6888C24.201 30.6018 24.0692 30.628 23.9968 30.7514C23.908 30.9032 23.9523 31.1279 24.0917 31.2351L27.5855 33.9227C27.699 34.0098 27.8307 33.9835 27.9031 33.8601L32.3607 26.2545C32.4496 26.1027 32.4062 25.8779 32.2668 25.7707Z",
    fill: "#F3F0FF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4715 29.3191C60.3209 27.4697 62.8293 26.4307 65.4448 26.4307C68.0603 26.4307 70.5687 27.4697 72.4181 29.3191C74.2676 31.1685 75.3066 33.6769 75.3066 36.2924V49.4413C75.3066 52.0568 74.2676 54.5652 72.4181 56.4146C70.5687 58.264 68.0603 59.303 65.4448 59.303C62.8293 59.303 60.3209 58.264 58.4715 56.4146C56.622 54.5652 55.583 52.0568 55.583 49.4413V36.2924C55.583 33.6769 56.622 31.1685 58.4715 29.3191ZM65.4448 33.0051C64.573 33.0051 63.7368 33.3515 63.1204 33.9679C62.5039 34.5844 62.1575 35.4205 62.1575 36.2924V49.4413C62.1575 50.3131 62.5039 51.1493 63.1204 51.7657C63.7368 52.3822 64.573 52.7285 65.4448 52.7285C66.3166 52.7285 67.1528 52.3822 67.7692 51.7657C68.3857 51.1493 68.7321 50.3131 68.7321 49.4413V36.2924C68.7321 35.4205 68.3857 34.5844 67.7692 33.9679C67.1528 33.3515 66.3166 33.0051 65.4448 33.0051Z",
    fill: "#212529"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4715 29.3191C60.3209 27.4697 62.8293 26.4307 65.4448 26.4307C68.0603 26.4307 70.5687 27.4697 72.4181 29.3191C74.2676 31.1685 75.3066 33.6769 75.3066 36.2924V49.4413C75.3066 52.0568 74.2676 54.5652 72.4181 56.4146C70.5687 58.264 68.0603 59.303 65.4448 59.303C62.8293 59.303 60.3209 58.264 58.4715 56.4146C56.622 54.5652 55.583 52.0568 55.583 49.4413V36.2924C55.583 33.6769 56.622 31.1685 58.4715 29.3191ZM65.4448 33.0051C64.573 33.0051 63.7368 33.3515 63.1204 33.9679C62.5039 34.5844 62.1575 35.4205 62.1575 36.2924V49.4413C62.1575 50.3131 62.5039 51.1493 63.1204 51.7657C63.7368 52.3822 64.573 52.7285 65.4448 52.7285C66.3166 52.7285 67.1528 52.3822 67.7692 51.7657C68.3857 51.1493 68.7321 50.3131 68.7321 49.4413V36.2924C68.7321 35.4205 68.3857 34.5844 67.7692 33.9679C67.1528 33.3515 66.3166 33.0051 65.4448 33.0051Z",
    fill: "#7950F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3967 26.6761C50.6009 27.1749 51.3861 28.35 51.3861 29.6535V55.4353C51.3861 57.2152 49.9433 58.658 48.1634 58.658C46.3835 58.658 44.9406 57.2152 44.9406 55.4353V37.4338L43.9967 38.3777C42.7381 39.6363 40.6976 39.6363 39.439 38.3777C38.1805 37.1192 38.1805 35.0787 39.439 33.8201L45.8846 27.3747C46.8063 26.453 48.1924 26.1773 49.3967 26.6761Z",
    fill: "#212529"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3967 26.6761C50.6009 27.1749 51.3861 28.35 51.3861 29.6535V55.4353C51.3861 57.2152 49.9433 58.658 48.1634 58.658C46.3835 58.658 44.9406 57.2152 44.9406 55.4353V37.4338L43.9967 38.3777C42.7381 39.6363 40.6976 39.6363 39.439 38.3777C38.1805 37.1192 38.1805 35.0787 39.439 33.8201L45.8846 27.3747C46.8063 26.453 48.1924 26.1773 49.3967 26.6761Z",
    fill: "#7950F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1685 18.1185L54.5361 14.1389L56.5258 10.9551L63.689 15.3325L61.1685 18.1185Z",
    fill: "#FFC9C9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M86.596 42.0927L81.3999 37.7953L83.2199 34.7146L88.8272 39.435L86.596 42.0927Z",
    fill: "#99E9F2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7791 22.1412L18.7858 19.3757L20.1494 17.4356L24.5539 18.0177L22.7791 22.1412Z",
    fill: "#99E9F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.84494 36.5746L5.40418 32.0609L6.60661 34.4605L1.63593 39.3165L0.84494 36.5746Z",
    fill: "#99E9F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3609 75.2996L15.4863 72.0896L16.2661 73.7512L12.8595 77.2055L12.3609 75.2996Z",
    fill: "#7950F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6393 20.5933L69.5399 17.6986L70.9399 19.6125L66.6806 22.7199L65.6393 20.5933Z",
    fill: "#7950F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6645 3.10796L31.9711 5.59299L33.0641 9.42867L27.2842 6.66177L26.6645 3.10796Z",
    fill: "#99E9F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2656 19.7221L27.6377 17.0988L26.3261 15L21.6041 17.8856L23.2656 19.7221Z",
    fill: "#FFEC99"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3588 2.79232L66.9335 2.61149L65.9479 1.22206L61.0001 1.44352L62.3588 2.79232Z",
    fill: "#FFEC99"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6421 13.5031L66.8855 14.603L67.7578 12.9954L64.2215 11.8306L63.6421 13.5031Z",
    fill: "#FFEC99"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3651 74.8733L47.5154 76.4766L48.9744 73.9156L43.3576 72.2217L42.3651 74.8733Z",
    fill: "#FFEC99"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5815 11.2428L16.2139 7.26314L15.0687 5.51953L8.48869 9.48667L9.5815 11.2428Z",
    fill: "#FFC9C9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5199 5.19806L77.3073 10.2908L78.2028 7.66631L75.4103 3.06162L74.5199 5.19806Z",
    fill: "#FFC9C9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7847 80.6039L80.7343 81.2276L79.6709 79.1123L75.0221 78.7578L75.7847 80.6039Z",
    fill: "#FFC9C9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0659 35.8115L20.6982 33.2801L18.7085 31.2549L11.5454 34.0393L14.0659 35.8115Z",
    fill: "#FFC9C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2475_17951",
    x: 7.9,
    y: 68.3795,
    width: 93.8686,
    height: 30.9295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.677775 0 0 0 0 0.599488 0 0 0 0 0.903602 0 0 0 0.61 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_17951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_17951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2475_17951",
    x: 16.2744,
    y: 37.5625,
    width: 19.9834,
    height: 20.0615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700697 0 0 0 0 0.642201 0 0 0 0 0.865216 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_17951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_17951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2475_17951",
    x: 18.7129,
    y: 53.1084,
    width: 19.9834,
    height: 20.0596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700697 0 0 0 0 0.642201 0 0 0 0 0.865216 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_17951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_17951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2475_17951",
    x: 14.0918,
    y: 21.0508,
    width: 19.9834,
    height: 20.0596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700697 0 0 0 0 0.642201 0 0 0 0 0.865216 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_17951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_17951",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.b775eba1654145f120b9fae818fd06cc.svg";
export { ForwardRef as ReactComponent };